import React from 'react'
import { BaseCard } from './BaseCard'
import { APIClient } from '@/services'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'
import { FeedOptionsSelector } from '../../organisms/OptionsSelector'

export const GenderCard = ({ item }: RenderItemProps) => {
  const { data: options } = APIClient.Session.useProfileOptions()

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <FeedOptionsSelector data={options?.gender} {...prompt.form.register('gender')}/>
    </BaseCard>
  )
}
